import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Grid, Typography, Tooltip } from '@material-ui/core';
import { GridDataTooltip } from './components/StyledGrids';

/**
 * Field for displaying potentially long data without breaking layout
 */
export const FieldToolTip = ({
  label,
  data,
  classes = {},
  TooltipProps = {
    classes: {}
  }
}) => /*#__PURE__*/React.createElement(Grid, {
  className: classes.fieldToolTipContainer,
  container: true,
  item: true,
  xs: 12
}, /*#__PURE__*/React.createElement(Grid, {
  xs: 6,
  sm: 3,
  md: 2,
  item: true
}, /*#__PURE__*/React.createElement(Typography, {
  className: classes.label,
  style: {
    whiteSpace: 'pre'
  }
}, label, ":", ' ')), /*#__PURE__*/React.createElement(Tooltip, _extends({
  title: /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, data)),
  classes: _objectSpread({
    popper: classes.toolTipPopper
  }, TooltipProps.classes),
  placement: "bottom-start",
  interactive: true
}, TooltipProps), /*#__PURE__*/React.createElement(GridDataTooltip, {
  item: true,
  xs: true,
  zeroMinWidth: true
}, /*#__PURE__*/React.createElement(Typography, {
  color: "primary",
  noWrap: true
}, data))));